var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"inline-flex text-white rounded-full h-6 px-3 justify-center items-center text-",class:_vm.state.color},[_vm._v(_vm._s(_vm.state.nome))])
}
var staticRenderFns = []

export { render, staticRenderFns }